// Neutral
/**
 * @deprecated Use WHITE instead
 */
export const OLAF = '#ffffff';
/**
 * @deprecated Use NEUTRAL_100 instead
 */
export const GYPSUM = '#f5f8fa';
/**
 * @deprecated Use NEUTRAL_200 instead
 */
export const KOALA = '#eaf0f6';
/**
 * @deprecated Use NEUTRAL_300 instead
 */
export const GREAT_WHITE = '#dfe3eb';
/**
 * @deprecated Use NEUTRAL_400 instead
 */
export const BATTLESHIP = '#cbd6e2';
/**
 * @deprecated Use NEUTRAL_500 instead
 */
export const FLINT = '#99acc2';
/**
 * @deprecated Use NEUTRAL_600 instead
 */
export const EERIE = '#7c98b6';
/**
 * @deprecated Use NEUTRAL_700 instead
 */
export const SLINKY = '#516f90';
/**
 * @deprecated Use NEUTRAL_800 instead
 */
export const HEFFALUMP = '#425b76';
/**
 * @deprecated Use NEUTRAL_900 instead
 */
export const PANTERA = '#2d3e50';

// Calypso
export const CALYPSO = '#00a4bd';
export const CALYPSO_DARK = '#0091ae';
export const CALYPSO_MEDIUM = '#7fd1de';
export const CALYPSO_LIGHT = '#e5f5f8';

// Obsidian
export const OBSIDIAN = '#33475b';

// Cirrus
export const CIRRUS = '#f2f5f8';

// Norman
export const NORMAN = '#f2547d';
export const NORMAN_DARK = '#d94c71';
export const NORMAN_MEDIUM = '#f9aabe';
export const NORMAN_LIGHT = '#fdedf2';

// Candy Apple
export const CANDY_APPLE = '#f2545b';

// Oz
export const OZ = '#00bda5';
export const OZ_DARK = '#00a38d';
export const OZ_MEDIUM = '#7fded2';
export const OZ_LIGHT = '#e5f8f6';

// Misc.
export const BUTTON_DISABLED_TEXT = BATTLESHIP;

// Chart Colors
export const CHART_GREEN = '#a2d28f';
export const CHART_ORANGE = '#fea58e';
export const CHART_RED = '#ea90b1';

// Trellis Smiley Colors
export const TRELLIS_HAPPY = '#6ACB8C';
export const TRELLIS_NEUTRAL = '#EEB117';
export const TRELLIS_SAD = '#FF7B70';

// Marigold
export const MARIGOLD = '#f5c26b';
export const MARIGOLD_DARK = '#dbae60';
export const MARIGOLD_MEDIUM = '#fae0b5';
export const MARIGOLD_LIGHT = '#fef8f0';

// Thunderdome
export const THUNDERDOME = '#6a78d1';
export const THUNDERDOME_DARK = '#5e6ab8';
export const THUNDERDOME_MEDIUM = '#b4bbe8';
export const THUNDERDOME_LIGHT = '#f0f1fa';
export const WHITE = '#ffffff';
export const NEUTRAL_100 = '#f8f7f6';
export const NEUTRAL_200 = '#f5f3f2';
export const NEUTRAL_300 = '#efedeb';
export const NEUTRAL_400 = '#e7e5e4';
export const NEUTRAL_500 = '#cfcccb';
export const NEUTRAL_600 = '#b6b1af';
export const NEUTRAL_700 = '#9b9897';
export const NEUTRAL_750 = '#666666';
export const NEUTRAL_800 = '#676565';
export const NEUTRAL_900 = '#4d4c4c';
export const NEUTRAL_1000 = '#333333';
export const NEUTRAL_1100 = '#292929';
export const NEUTRAL_1200 = '#242424';
export const NEUTRAL_1300 = '#1f1f1f';
export const NEUTRAL_1400 = '#1c1c1c';
export const NEUTRAL_1500 = '#171717';
export const NEUTRAL_1600 = '#141414';